module.exports = {"id":"191089","name":"Connor Wickham","rating":"72","photo":"./data/images/photos/2/191089.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ConnorWickham0.json
// module id = 849
// module chunks = 0